// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__16F1u","footer":"ModalCreateQualiphyProcedure_footer__2Ozz6","additionData":"ModalCreateQualiphyProcedure_additionData__2RoTx"};